import React, { useState } from 'react';
import { CNav, CNavItem, CNavLink, CTooltip, CModal, CModalBody } from '@coreui/react';
import Select from 'react-select';
import { Info } from 'lucide-react';
import QuestionDropdownBuilder from './QuestionDropdownBuilder';
import QuestionTextInputFormBuilder from './QuestionTextInputFormBuilder';

const QuestionDropdownPreview = ({
  dropdownInput,
  setDropdownInput,
  previewActiveTab,
  setPreviewActiveTab,
  selectOption,
  setSelectOption,
  questionClicked,
  setCurrentTextInputs,
  currentTextInputs
}) => {
  const [editQuestion, setEditQuestion] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [typeOfQuestion, setTypeOfQuestion] = useState(null);


  // console.log("edit question ", editQuestion)
  const openEditModal = (question) => {
    console.log("---------------------------")
    console.log("selected option ", question) 
    setTypeOfQuestion(question.type);
    if (question.type === 'input') {
      setCurrentTextInputs(question)
    }
    setEditQuestion(question);
    setIsEditModalVisible(true);
  };

  const saveEditedQuestion = (updatedQuestion) => {
    console.log("--------------------------------");
    console.log("Updated Question", updatedQuestion);

    let isFound = false; // Flag to track if the question ID is found

    // Recursive function to update linked questions
    const updateLinkedQuestions = (questions) => {
        if (!questions || !Array.isArray(questions)) return questions;

        return questions.map((question) => {
            if (question.id === editQuestion?.id) {
                isFound = true; // Mark as found
                return updatedQuestion; // Update the question
            }

            // Recursively check and update nested linked questions
            if (question.options && Array.isArray(question.options)) {
                question.options = question.options.map((option) => {
                    if (option.linkedQuestion) {
                        option.linkedQuestion = updateLinkedQuestions(option.linkedQuestion);
                    }
                    return option;
                });
            }

            return question;
        });
    };

    // Iterate over dropdown options and update linked questions
    const updatedOptions = dropdownInput.options.map((option) => {
        if (option?.linkedQuestion) {
            option.linkedQuestion = updateLinkedQuestions(option.linkedQuestion);
        }
        return option;
    });

    if (!isFound) {
        // Alert if the ID was not found
        alert("Linked question ID not found!");
        return; // Exit the function
    }

    // Update state with modified options
    setDropdownInput((prev) => ({
        ...prev,
        options: updatedOptions,
    }));

    // Reset modal and editing state
    setIsEditModalVisible(false);
    setEditQuestion(null);
};


  
  // console.log("dropdown input", dropdownInput);
  const renderTreeOptions = (options) => (
    <ul style={{ listStyleType: 'none', paddingLeft: '1.5rem' }}>
      {options.map((option, index) => {
        // Normalize linkedQuestion into a list if it's an object
        const linkedQuestions = Array.isArray(option.linkedQuestion)
          ? option.linkedQuestion
          : option.linkedQuestion
          ? [option.linkedQuestion]
          : [];
  
        return (
          <li
            key={index}
            className="custom-form-builder-theme__tree-card"
          >
            <span
              className="custom-form-builder-theme__tree-label"
              onClick={() => {console.log("li");openEditModal(option)}}
            >
              {option?.label}
            </span>
            {option.providerInstruction && (
              <div className="custom-form-builder-theme__tree-instruction">
                <em>{option.providerInstruction}</em>
              </div>
            )}
            {option.options && (
              <div className="custom-form-builder-theme__tree-branch">
                <strong>Options:</strong>
                <ul style={{ listStyleType: 'none', paddingLeft: '1.5rem' }}>
                  {option.options.map((childOption, childIndex) => (
                    <li
                      key={childIndex}
                      className="custom-form-builder-theme__tree-child"
                      onClick={() => {console.log("option.options");openEditModal(childOption)}}
                    >
                      {childOption.label}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {linkedQuestions.length > 0 && (
              <div className="custom-form-builder-theme__tree-branch">
                <strong>Linked Questions:</strong>
                <ul style={{ listStyleType: 'none', paddingLeft: '1.5rem' }}>
                  {linkedQuestions.map((linkedQuestion, linkedIndex) => (
                    <li key={linkedIndex}>
                      <span
                        className="custom-form-builder-theme__tree-linked"
                        onClick={() =>{console.log("linkedQuestion"); openEditModal(linkedQuestion)}}
                      >
                        {linkedQuestion.label}
                      </span>
                      {/* Recursively render options and linked questions */}
                      {linkedQuestion.options && renderTreeOptions(linkedQuestion.options)}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
  
  

  const handleModalClose = () => {
    setIsEditModalVisible(false);
  }

  return (
    <div className="d-flex align-items-center justify-content-center flex-column" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <CNav variant="pills" className="w-100 justify-content-center" style={{ marginBottom: '1.5rem' }}>
        <CNavItem>
          <CNavLink active={previewActiveTab === 'question'} onClick={() => setPreviewActiveTab('question')} style={{
            borderRadius: '20px',
            fontWeight: previewActiveTab === 'question' ? '600' : '400',
          }}>
            Question
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink active={previewActiveTab === 'tree'} onClick={() => setPreviewActiveTab('tree')} style={{
            borderRadius: '20px',
            fontWeight: previewActiveTab === 'tree' ? '600' : '400',
          }}>
            Tree View
          </CNavLink>
        </CNavItem>
      </CNav>

      <div
        className="custom-form-builder-theme__builder-preview w-200 p-4"
        style={{
          width: '37vw',
          borderRadius: '12px',
          padding: '2rem',
        }}
      >
        {previewActiveTab === 'question' ? (
          <div className="boxPreview w-100">
            <div className="d-flex align-items-center gap-2 mb-3" style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
              <p className="p-0 m-0 text-left">{dropdownInput.label || 'Question'}</p>
              <CTooltip content={dropdownInput.toolTipValue || "Add the tooltip"}>
                <Info size={18} />
              </CTooltip>
            </div>

            <Select
              isMulti={dropdownInput.isMultiple}
              options={dropdownInput.options ? dropdownInput.options.map((item) => ({
                value: item.value,
                label: item.label
              })) : []}
              onChange={(selected) => {
                const selectedValues = Array.isArray(selected) && selected.length > 0 ? selected.map(option => option) : selected ? [selected] : [];
                setSelectOption((prev) => ({
                  ...prev,
                  selectedValues
                }));
              }}
              className="basic-single-select"
              classNamePrefix="select"
            />

            {selectOption?.selectedValues?.length > 0 && dropdownInput?.options.map((item) => {
              { console.log("preview question , and selected option", item, item.value, selectOption.selectedValues[0]?.value) }
              if (item.value === selectOption.selectedValues[0]?.value && item.providerInstruction) {
                return (
                  <div key={item.value} className="custom-form-builder-theme__provider-info mt-2">
                    <p>
                      <span className="custom-form-builder-theme__provider-info-label fw-semibold">Provider Instruction:</span>{' '}
                      {item.providerInstruction}
                    </p>
                  </div>
                );
              }
              return null;
            })}

            {dropdownInput.providerInfo && (
              <div className="custom-form-builder-theme__provider-info mt-2">
                <p>
                  <span className="custom-form-builder-theme__provider-info-label fw-semibold">Provider Information:</span>{' '}
                  {dropdownInput.providerInfo}
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className="treePreview w-100">
            <div className="d-flex align-items-center gap-2 mb-3" style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
              <p className="p-0 m-0 text-left">{dropdownInput.label || 'Question Tree'}</p>
            </div>
            <div style={{ paddingLeft: '1rem' }}>
              {dropdownInput.options && renderTreeOptions(dropdownInput.options)}
            </div>
          </div>
        )}
      </div>
      <CModal
        className="custom-form-builder-theme__editor-modal"
        size='xl'
        visible={isEditModalVisible}
        onClose={handleModalClose}
      >
        <CModalBody className="custom-form-builder-theme__editor-modal-body" style={{ padding: '1.5rem' }}>

          {typeOfQuestion === 'input' ?
            (
              editQuestion && <QuestionTextInputFormBuilder
                saveMode="options"
                mode={"Edit"}
                setIsOpenModal={handleModalClose}
                currentTextInputs={currentTextInputs}
                saveQuestion={saveEditedQuestion}
                styling={'show'}
                setCurrentTextInputs={setCurrentTextInputs}
                setEditQuestion={setEditQuestion}
              />

            ) : (
              editQuestion && <QuestionDropdownBuilder
                saveMode="options"
                mode={"Edit"}
                setIsOpenModal={handleModalClose}
                dropdownInput={editQuestion}
                saveQuestion={saveEditedQuestion}
                styling={'show'}

              />
            )
          }

        </CModalBody>
      </CModal>
    </div>
  );
};

export default QuestionDropdownPreview;
